/*
 * サブシステム名：
 * 機能名：配車表入力
 * 表示項目カスタマイズ(マーキュリー)
 */
import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'
// import date from '@/ddv2.library/date'
// import indexeddb from '@/ddv2.library/indexeddb'
// import filter from '@/rahmen/utils/filters'

export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForMrc',
  data: () => ({
  }),
  computed: {
  },
  methods: {
    // 固有カスタマイズ：保存時に発地日(hatsuchiYmd)を運行日(sagyoYoteiYmd)に設定する
    // 固有カスタマイズ：保存時に単価(tanka)を受注明細レベルの基本運賃(meisaiKihonUnchin)に設定する
    saveAction: function () {
      this.targetList.forEach((elem) => {
        if (![undefined, null, ''].includes(elem.hatsuchiYmd)) {
          elem.sagyoYoteiYmd = elem.hatsuchiYmd
        }
        if (![undefined, null, ''].includes(elem.tanka)) {
          elem.meisaiKihonUnchin = elem.tanka
        }
        if (![undefined, null, ''].includes(elem.sharyoHanyoText1)) {
          elem.shiharaiText2 = elem.sharyoHanyoText1
        }
      })
      D2PLMD1010.methods.saveAction.call(this)
    }
  }
}
